import { render } from "./NumberRating.vue?vue&type=template&id=82e188aa&scoped=true"
import script from "./NumberRating.vue?vue&type=script&lang=js"
export * from "./NumberRating.vue?vue&type=script&lang=js"

import "./NumberRating.vue?vue&type=style&index=0&id=82e188aa&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-82e188aa"]])

export default __exports__